import { render, staticRenderFns } from "./oldHost.vue?vue&type=template&id=f1ba3096&scoped=true&"
import script from "./oldHost.vue?vue&type=script&lang=js&"
export * from "./oldHost.vue?vue&type=script&lang=js&"
import style0 from "./oldHost.vue?vue&type=style&index=0&id=f1ba3096&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ba3096",
  null
  
)

export default component.exports